import styled from '@emotion/styled';
import { COLORS, RADIUSES } from '@sortlist-frontend/design-system/legacy';

export const StickyBlock = styled.div`
  top: 2rem;
`;

export type IndexProps = {
  selected?: boolean;
};

export const IndexItem = styled.div`
  ${(props: IndexProps) => `
  color: ${props.selected ? COLORS.PRIMARY_500 : COLORS.SECONDARY_900};
  background-color: ${props.selected ? COLORS.PRIMARY_100 : 'transparent'};

  &:hover {
    color: ${COLORS.PRIMARY_500};
    background-color: ${COLORS.PRIMARY_100};
    svg {
      color: ${COLORS.PRIMARY_500};
    }
  }
`}
`;

export const Gradient = styled.div`
  pointer-events: none;

  &:after {
    content: '';
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: ${RADIUSES.md};
    background: linear-gradient(
      180deg,
      rgba(250, 250, 250, 0) 0%,
      rgba(250, 250, 250, 0) 75%,
      rgba(250, 250, 250, 1) 100%
    );
  }
`;

export const ScrollingArea = styled.div`
  max-height: 20rem;
  pointer-events: auto;
`;
